module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("R.")]), _vm._v(" E"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("VANS WENT")]), _vm._v(" next door and unlocked the drug cabinet. They had already moved most of their supplies, but they still had a few drugs left. There were two locked cabinets in the room. One contained the drugs for their small infirmary. The other was a classified enclosure where they stored the results of their work.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Dr. Evans received his notice that he had to retire by the end of the year, he had been supervising the preparation of the DNA they had extracted from Adamartoni’s sarcophagus.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Infuriated at being forced to retire, he decided to sell some of the DNA to fund his retirement. He took half their available recombinant DNA solution and stored it in an antibiotic bottle. He placed it in the back of the classified storage cabinet. He had been sure it would be safe in there since he and his boss were the only ones with keys.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As part of the closing procedure his boss had taken an inventory of the two cabinets before he left for the Sandia location. When he found the antibiotic bottle in the classified cabinet, he assumed it was a mistake and moved it to the drug cabinet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Dr. Evans opened the drug cabinet, selected the correct bottle, and filled a syringe with the Levofloxacin. As he walked down the hall, he thought about what he would do with the money he would get from selling the DNA to the drug company. The DNA had been prepared to be used in a recombinant DNA experiment, but that had all changed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As he thought back to events which had occurred in the previous months, he remembered the day they were going to try to open the sarcophagus. Just before they made their first cut, they discovered it was covered with text. The etchings were almost microscopic, and required extreme magnification to be able to copy them. By the time the linguistics team finished copying the text they had over ten thousand pages of text. They detailed Adamartoni and Evevette’s lives, teachings, and described how Evevette had entombed him in the sarcophagus almost a hundred thousand years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They were members of a race called the Theos, and an earthquake had damaged their ship stranding them in what would someday be Mesopotamia. There were several references to a ship and someone or something called Xylon. They had assumed the ship to be a sailing ship, until their field team unearthed the remains of what they believed to be a spaceship. There wasn’t much of it left, so they were never completely sure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The final section of the text described an event which would occur in what then was the distant future. It described how a passing comet would alter the path of an immense asteroid and cause it to strike the Earth. In the final few paragraphs, it described how a young couple would be the salvation of humanity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("By the time they finished analyzing the text, they had come to believe the text detailed some of the events described in Second Peter. Like many of the original Biblical texts, the message was somewhat altered as it had been translated and retranslated over the centuries.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He hated to miss seeing how it all played out, but at least he was going to be able to retire in comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave the baby the shot of antibiotic and asked, “Have you thought of a name yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, we have,” Mary West said. “We’ve decided to name him Billy Wayne West. We decided since you were so nice to us, we wanted to name him after you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you both, but I was just doing my job,” Dr. Evans said. “I’m going to go call the officer of the day and let him know we have one more visitor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m so excited, and the baby is so cute,” Mary West said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He sure is,” Ben West said. “It sure was lucky we turned down the road. We could have been in real trouble if we had stayed on the highway.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You know what my momma always said,” Mary West said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“‘Everything happens for a purpose.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I guess she’s right for sure this time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The lieutenant says the roads are all closed, and you’ll need to stay the night with us,” Dr. Evans said. “I’ve had one of the suites on this floor prepared for you to stay in tonight. The kitchen will bring your dinner in an hour or so.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re going to roll the exam table down the hall to your room. I don’t want you to have to walk any more than necessary. If you’ll grab the other end of the table we’ll get Mary to her room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Make yourselves at home, and try to get comfortable. I’ll be back with your dinner,” Dr. Evans said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When their meals arrived, he took them to their room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Here’s your dinner and a pot of coffee. If you need anything during the night, I’m down the hall in room ten.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, we’re both pretty tired, and with the day Mary has had, I don’t think she will be moving around very much,” Ben West said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t get over how nice the doctor was today. He has tried to make us comfortable,” Ben said after the doctor had left.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He did well, but I was worried when he said the baby needed a shot of antibiotics.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I know, but he said it was nothing but a fever and some congestion.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Billy looks good, and he’s nursing, so I think he’s going to be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The next morning the storm had blown through, and the sun was shining brightly when they awoke and looked out their windows.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The sun is out, and it’s a beautiful day,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good, I wouldn’t want to have many more days like yesterday.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m going to find the doctor and see what we need to do to get into town.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He had just started down the hall, when he heard the doctor’s voice.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How are you two this morning?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’re great, but we’re ready to get going.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great minds think alike. I had one of the Marines pull your Suburban over to the motor pool last night. He told me they should have it ready after lunch.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Right now, I have breakfast for you two. I would also like to examine Mary and the baby if it’s all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure, come on in.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good morning. How did you sleep?” Dr. Evans asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I slept fine, except for caring for the baby from time to time. I think we’re both fine, but come ahead and check us out.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He spent a few minutes examining her and said, “Everything looks fine so far.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Great, when do you think we can go home?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“As I was telling Ben, they should have your car ready right after lunch.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We can never thank you enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s been my pleasure to experience delivering your baby and meeting you two.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m going to examine the baby, and then I’ll bring in your breakfast.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He checked the baby from head to toe, and when he finished he said, “The baby checks out fine. His temperature is a tiny bit high, but it’s nothing to be alarmed about, the antibiotics should take care of it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thanks, we’ll have Dr. Moore check him out when we get home,” Ben said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Where is home?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We live on a small ranch in New Mexico. It’s about eight miles northeast of Clayton, New Mexico.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve heard of it, but I’m not sure where it is. How far is it from Amarillo?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s about a hundred and thirty miles northwest of Amarillo, Texas.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How long do you think it will take you to get back?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If the roads aren’t too bad, it should take us three and a half to four hours. If we get out of here by one o’clock, we should be home just about dark.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m going to have the staff bring your breakfast in. Then I’ll go check on your car so we can get you on your way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They finished breakfast and Mary asked, “Will you hold Billy while I take a shower and fix my hair?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure, go ahead. You’ve had a rough time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It wasn’t as bad as I had feared. He sure didn’t put up much of a fuss coming. It seemed like he was ready to get started.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After her shower, she sat down in one of the chairs to rest and feed the baby. She had just finished when the doctor returned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good news. We have your car ready, and they filled it with gas. The restaurant sent some sack lunches and drinks for the ride home.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“They didn’t have to go to all that trouble,” Mary said. “Please tell them thanks for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I won’t have to. They’re all waiting outside to say goodbye to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well then, let’s go thank them.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they came out, there was a cheer from the twenty or so Marines, cooks, mechanics, and technicians standing outside. They had been waiting for ten minutes on the snow-covered ground.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you so much for everything. We can’t thank you enough,” Mary said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You just take good care of the baby, and it will be thanks enough for us,” the motor pool sergeant said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You can count on it, and we’ll never forget all of you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Ben started the Suburban, the motor was running smoother than it had in months. He rolled down his window and said, “You guys did a great job fixing up the motor. It sounds great.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We didn’t exactly fix it. We put in a motor out of one of the staff vehicles. We’ll put your old motor in it, and fix it up after you are gone.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ben was speechless, but Mary rolled her window down again, blew them all a kiss, and said, “God bless all of you, and thanks again for all you’ve done for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they began their journey back home, they had no way of knowing what their inadvertent stop had set in motion.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7249c335","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780765358493_ch03.vue
// module id = 87
// module chunks = 0